import { useAuth } from "../context/AuthContext";
import { Navigate } from "react-router-dom";
import { Users, Sprout, ArrowRight, Heart } from "lucide-react";

export default function Login() {
  const { user, loading } = useAuth();
  if (!loading && user) return <Navigate to="/" replace />;

  const handleLogin = () => {
    // REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
    const redirectUrl = window.location.origin + "/";
    window.location.href = `https://auth.emergentagent.com/?redirect=${encodeURIComponent(redirectUrl)}`;
  };

  return (
    <div className="min-h-screen bg-background flex" data-testid="login-page">
      <div className="flex-1 flex flex-col justify-center px-8 sm:px-16 lg:px-24">
        <div className="max-w-md space-y-10">
          <div className="space-y-3">
            <img src="/logo-trim.png" alt="Bouquet" data-testid="brand-logo" className="h-36 w-72 object-contain rounded-xl" />
            <p className="text-muted-foreground text-sm sm:text-base leading-relaxed">
              Take meaningful next steps toward things that matter to you — supported by the people
              and communities you already trust. Not a social network. A bird's-eye view of what's growing.
            </p>
          </div>

          <div className="space-y-4">
            {[
              { icon: Sprout, text: "Name what's growing, choose one next step" },
              { icon: Users, text: "Share it with a small pod you trust — on your terms" },
              { icon: Heart, text: "Receive support, reflect, and keep moving" },
            ].map(({ icon: Icon, text }, i) => (
              <div key={i} className="flex items-center gap-3 text-sm text-foreground/80">
                <div className="h-8 w-8 rounded-lg bg-secondary flex items-center justify-center shrink-0">
                  <Icon className="h-4 w-4 text-primary" />
                </div>
                {text}
              </div>
            ))}
          </div>

          <button
            data-testid="google-login-button"
            onClick={handleLogin}
            className="group flex items-center gap-3 bg-primary text-primary-foreground px-6 py-3.5 rounded-full text-sm font-semibold hover:opacity-90 transition-opacity"
          >
            Continue with Google
            <ArrowRight className="h-4 w-4 transition-transform group-hover:translate-x-1" />
          </button>
          <p className="text-xs text-muted-foreground" data-testid="login-new-here">
            New here? You'll create your Bouquet in seconds — no invite needed.
          </p>
          <p className="text-xs text-muted-foreground">
            Private by default. You decide what to share, and with whom. Always.
          </p>
        </div>
      </div>
      <div className="hidden lg:block flex-1 relative overflow-hidden">
        <img
          src="https://images.unsplash.com/photo-1767552659473-9a541393de94?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxNzV8MHwxfHNlYXJjaHwxfHx3aGltc2ljYWwlMjB3aWxkZmxvd2VycyUyMHNvZnQlMjBwYXN0ZWwlMjBmZW1pbmluZXxlbnwwfHx8fDE3OTExNjYzNDJ8MA&ixlib=rb-4.1.0&q=85"
          alt="A soft, whimsical bouquet of flowers"
          className="absolute inset-0 h-full w-full object-cover"
        />
        <div className="absolute inset-0 bg-primary/40" />
      </div>
    </div>
  );
}
